import { all, takeLatest, put } from 'redux-saga/effects';
import {
    GET_PLAYERS,
    DELETE_QUIZ_USER_PLAYER,
    PSEUDONONYMIZE_PLAYER,
    DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE,
    DELETE_QUIZ_ALL_USER_PLAYERS
} from './constants';
import {
    requestPlayers,
    requestQuizDeleteUserPlayer,
    requestPseudononymizePlayer,
    requestQuizExportFile,
    requestQuizDeleteAllUserPlayer
} from './api';
import {
    clearPlayers,
    getPlayersSuccess,
    deleteQuizUserPlayerSuccess,
    pseudononymizePlayerSuccess,
    downloadQuizPlayersExportFileSuccess,
    deleteQuizAllUserPlayersSuccess
} from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{players, type}>|PutEffect<{type}>>}
 */
function* getPlayers(actionObj) {

    yield put(clearPlayers());
    const players = yield requestPlayers(actionObj.id, actionObj.from, actionObj.to, actionObj.resolve);
    if(players) {
        yield put( getPlayersSuccess(players) ) ;
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{players, type}>>}
 */
function* deleteQuizUserPlayer(actionObj) {
    const players = yield requestQuizDeleteUserPlayer(actionObj.id, actionObj.quizID);
    if(players) {
        yield put(deleteQuizUserPlayerSuccess(players));
    }
}

function* pseudononymizePlayer(actionObj) {
    const players = yield requestPseudononymizePlayer(actionObj.id, actionObj.quizID);
    if(players) {
        yield put(pseudononymizePlayerSuccess(players));
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{file, type}>>}
 */
function* downloadQuizPlayersExportFile(actionObj) {
    const file = yield requestQuizExportFile(actionObj.quizID);
    if(file) {
        yield put(downloadQuizPlayersExportFileSuccess(file));
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{players, type}>>}
 */
function* deleteQuizAllUserPlayers(actionObj) {
    const players = yield requestQuizDeleteAllUserPlayer(actionObj.quizID, actionObj.typeData, actionObj.withPlayers);
    if(players) {
        yield put(deleteQuizAllUserPlayersSuccess(players));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchPlayers() {
    yield takeLatest(GET_PLAYERS, getPlayers);
    yield takeLatest(DELETE_QUIZ_USER_PLAYER, deleteQuizUserPlayer);
    yield takeLatest(PSEUDONONYMIZE_PLAYER, pseudononymizePlayer);
    yield takeLatest(DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE, downloadQuizPlayersExportFile);
    yield takeLatest(DELETE_QUIZ_ALL_USER_PLAYERS, deleteQuizAllUserPlayers);
}

function* playersSaga() {
    yield all([
        watchPlayers()
    ]);
}

export default playersSaga;